import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => JSON.parse(localStorage.getItem("ao_cart") || "[]"));
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("ao_cart", JSON.stringify(items));
  }, [items]);

  const add = (p) => {
    setItems((prev) => {
      const ex = prev.find((i) => i.id === p.id);
      if (ex) return prev.map((i) => (i.id === p.id ? { ...i, qty: Math.min(i.qty + 1, 20) } : i));
      return [...prev, { id: p.id, name: p.name, price: p.sale_price || p.price, image_url: p.image_url, origin: p.origin, qty: 1 }];
    });
    setOpen(true);
  };
  const setQty = (id, qty) => setItems((prev) => (qty < 1 ? prev.filter((i) => i.id !== id) : prev.map((i) => (i.id === id ? { ...i, qty: Math.min(qty, 20) } : i))));
  const clear = () => setItems([]);
  const total = items.reduce((s, i) => s + i.price * i.qty, 0);
  const count = items.reduce((s, i) => s + i.qty, 0);

  return <CartCtx.Provider value={{ items, add, setQty, clear, total, count, open, setOpen }}>{children}</CartCtx.Provider>;
}

export const useCart = () => useContext(CartCtx);
